export class PortalConfig {
    // #region Properties
    //Common
    title;
    version;
    versionName;
    versionState;
    pageTitle;
    pageTitleFull;
    footerInfo;
    //Layout
    layoutName;
    logoSimple;
    logoDefault;
    //Site
    domain;
    cookiePath;
    loginPageImage;
    loginMethods;
    //consent
    consentCookie;
    statistikCookie;
    consentShowBanner;
    //Api
    viewsUrl;
    apiUrl;
    stsUrl;
    apiClientID;
    apiClientSecret;
    apiScopes;
    //Logging
    loggingUrl;
    googleTag;
    publicUrl;
    loggedInUrl;
    //Options
    options = undefined;
    // #endregion
    // #region Constructor
    constructor(object) {
        //Data
        this.title = object.title;
        this.pageTitle = object.pageTitle;
        this.pageTitleFull = object.pageTitleFull;
        this.version = object.version;
        this.versionName = object.versionName;
        this.versionState = object.versionState;
        this.viewsUrl = object.viewsUrl;
        this.apiUrl = object.apiUrl;
        this.stsUrl = object.stsUrl;
        this.apiClientID = object.apiClientID;
        this.apiClientSecret = object.apiClientSecret;
        this.apiScopes = object.apiScopes;
        this.loginPageImage = object.loginPageImage;
        this.loginMethods = object.loginMethods;
        this.loggingUrl = object.loggingUrl;
        this.footerInfo = object.footerInfo;
        this.consentCookie = object.consentCookie;
        this.statistikCookie = object.statistikCookie;
        this.consentShowBanner = object.consentShowBanner;
        this.layoutName = object.layoutName;
        this.googleTag = object.googleTag;
        this.logoSimple = object.logoSimple;
        this.logoDefault = object.logoDefault;
        this.publicUrl = object.publicUrl;
        this.loggedInUrl = object.loggedInUrl;
        //Special
        if (typeof window === 'object') {
            this.domain = window.location.hostname;
        }
        else {
            // eslint-disable-next-line no-restricted-globals
            const url = new URL(self.location.origin);
            this.domain = url.hostname;
        }
        if (utils.isNullOrEmpty(this.layoutName)) {
            this.layoutName = 'g-ecommerce-layout';
        }
        if (!this.loginMethods) {
            this.loginMethods = [];
        }
        if (this.loginMethods.length == 0) {
            this.loginMethods.push({ name: 'user' });
        }
        if (!this.logoSimple) {
            this.logoSimple = {
                src: '/themes/portal/images/logo-288a-simple.svg',
                width: 150
            };
        }
        if (!this.logoDefault) {
            this.logoDefault = {
                src: '/themes/portal/images/logo-288a-default.svg',
                height: 50
            };
        }
        //Options
        if (object.options) {
            this.options = object.options;
        }
        //Calculate
        this.cookiePath = '/';
    }
    // #endregion
    //#region Core
    getPageTitle(title) {
        if (utils.isNullOrEmpty(title)) {
            return appHost.config.pageTitle;
        }
        else {
            return utils.format(appHost.config.pageTitleFull, title);
        }
    }
}
